import {useEffect } from "react";
import { getMUICache, appendStyleSheet, getImageUrl, getImageSize, convertEpochTime, getListButtonIcon, getImageId, fetchAnchorValue } from '../../common/utils';
import { CacheProvider } from '@emotion/react';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../components/IntersectionObserver/imageComponent';


const Card2 = (props: any) => {
    AddImageDimensions();
    SetHighPriorityImages();
    PreloadViewportImages();
    ImageLoader();

    useEffect(()=>{
        EagerLoadImages()
    },[]);
    const { index1, showTimeStamp, showAuthorName, item, isViewport, anchorLinksValue } = props;
    const { hl, au, imageid, pubInfo, wu, upd, tn, du } = item;
    const cache = getMUICache();
    let styles = require("./Herolayout.css");
    appendStyleSheet("HeroLayout", styles);

    return (
        <CacheProvider value={cache}>
            <div className='hero-layout heroLayoutTwo'>
                <div>
                    <a role="link" aria-label="Next Page" href={wu} target={fetchAnchorValue(anchorLinksValue, wu)}>
                        <span>
                            {/* {getImageSize(imageid) && <img width="596" height="447" alt="image" src={getImageUrl(id, getImageSize(imageid), 596, undefined, pubInfo.baseDomain, false, props.CONSTANTS)} />} */}

                            {index1 === 0 ? (getImageSize(imageid) &&
                                (<picture>
                                    {/* Add multiple source elements for different image sources */}
                                    <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 460, 345, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />
                                    <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 328, 246, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />
                                    {/* Fallback image for browsers that do not support the picture element */}
                                    {isViewport ? (<img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy" />)
                                        : (<img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy" />)}
                                </picture>)
                            ) : (getImageSize(imageid) &&
                                (<picture>
                                    {/* Add multiple source elements for different image sources */}
                                    <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 90, 68, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />
                                    <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 124, 93, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />
                                    {/* Fallback image for browsers that do not support the picture element */}
                                    {isViewport ? (<img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy" />)
                                        : (<img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy" />)}
                                </picture>))}


                            {(tn == "MEDIAAUDIO" || tn == "MEDIAVIDEO") &&
                                <div className='optionaliconswrap'>
                                    <span className='commonhandalebutton'>{getListButtonIcon(tn)}</span> <span className='videodu'> {du} Mins</span>
                                </div>
                            }
                        </span>

                        <div>
                            <h5> {hl}</h5>
                            <div className='hero-layout-bottom heroLayoutTwoBottom'>
                                {showAuthorName && <h6 className='author'>{au}</h6>}
                                {showTimeStamp && <h6 className='herodate'>{convertEpochTime(upd, 'updated', "DD MMM YYYY")}</h6>}

                            </div>
                        </div>
                    </a>
                </div>
            </div>

        </CacheProvider>
    )
}
export default Card2;

